import React, { useEffect } from 'react';

import combinedActions from '~redux/combinedActions';
import { useAppDispatch, useAppSelector } from '~redux/hooks';

import TabPageContainer from '~components/atoms/TabPageContainer';
import GoldTransactionSearchAndFilterBar from './GoldTransactionApprovalSearchAndFilterBar';
import GoldTransactionTable from './GoldTransactionApprovalTable';
import GoldTransactionPaginator from './GoldTransactionApprovalPaginator';
import ConfirmUpdateTransactionStatusModal from './ConfirmUpdateTransactionStatusModal';
import GoldTransactionApprovalProductDetailsTable from './GoldTransactionApprovalProductDetailsTable';

const BuyAndSellGoldApproval = () => {
    const dispatch = useAppDispatch();

    const transactionListingIndex = useAppSelector(state => state.approval.pendingTransactionListing.index);
    const isTransactionProductListingModalIsOpen = useAppSelector(state => state.gold.modals.transactionProductListingModalIsOpen);
    const getTransactionListingAttempt = useAppSelector(state => state.gold.loadings.getTransactionListing);

    const setTransactionProductListingModalIsOpen = (state: boolean) => dispatch(combinedActions.goldSetTransactionProductListingModalIsOpen(state));

    useEffect(() => {
        dispatch(combinedActions.approvalGetPendingTransactionListingAttempt());
    }, [transactionListingIndex]);

    return (
        <TabPageContainer>
            <GoldTransactionSearchAndFilterBar />

            <GoldTransactionTable />

            <GoldTransactionPaginator />

            <ConfirmUpdateTransactionStatusModal />

            <GoldTransactionApprovalProductDetailsTable
                isOpen={isTransactionProductListingModalIsOpen}
                onClose={() => setTransactionProductListingModalIsOpen(false)}
                isLoading={getTransactionListingAttempt}
            />
        </TabPageContainer>
    );
};

export default BuyAndSellGoldApproval;
